import { Component } from '@angular/core';

@Component({
  selector: 'app-parking',
  standalone: false,
  templateUrl: './parking.component.html',
  styleUrl: './parking.component.scss'
})
export class ParkingComponent {

  parkingRedirectUrl = 'https://www.onepark.co/es?utm_medium=Affiliates&utm_source=cafler';

  redirectToParking() {
    window.open(this.parkingRedirectUrl, '_blank');
  }

}
